import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from 'consts';
import PaymentDetails from './components/PaymentDetails';
import ErrorMessage from './components/ErrorMessage';
import { createContractAndStripePaymentIntent } from './state/paymentIntent';
import StepView from '../../../components/StepView';
import { Spinner } from './styled';
import { useStepNavigationContext } from '../../../context';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const StripePaymentProvider = () => {
  const dispatch = useDispatch();
  const { jumpToFirstStep } = useStepNavigationContext();
  const { paymentIntent } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.independencePayment
  );
  const { isValid } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.review
  );

  const { pollPaymentStatus, isLoading: isPaymentStatusLoading } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.independencePayment.paymentStatus
  );

  const {
    error: paymentIntentError,
    isLoading: isPaymentIntentLoading,
    clientSecret
  } = paymentIntent;

  if (!isValid) {
    jumpToFirstStep();
  }

  useEffect(() => {
    dispatch(createContractAndStripePaymentIntent());
  }, []);

  const stripeOptions = {
    clientSecret,
    appearance: {
      theme: 'stripe'
    }
  };

  if (!isPaymentIntentLoading && paymentIntentError) {
    return (
      <StepView>
        <ErrorMessage error={paymentIntentError} />
      </StepView>
    );
  }

  if (pollPaymentStatus.isTimedOut) {
    // no reply from stripe, stuck in payment pending state
    return (
      <StepView>
        <ErrorMessage />
      </StepView>
    );
  }

  if (
    isPaymentIntentLoading ||
    !clientSecret ||
    !stripePromise ||
    pollPaymentStatus.isPolling ||
    isPaymentStatusLoading
  ) {
    return <Spinner variant="dark" />;
  }

  return (
    <Elements options={stripeOptions} stripe={stripePromise}>
      <StepView>
        <PaymentDetails />
      </StepView>
    </Elements>
  );
};

export default StripePaymentProvider;
